<div class="main-container">
  <div class="grid-container" id="diag-report-grid-container" style="height: calc(100vh - 124px);">
    <div class="top-toolbar">
      <div class="toolbar-actions">
        @if (taxyearLoaded) {
          <!-- <p-select class="mr-2" [options]="taxYears" optionLabel="text" [(ngModel)]="taxYear"
            (onChange)="onTaxYearChange()">
          </p-select> -->
          <ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'"
            [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYearItem"
            (onSelect)="onTaxYearChanged($event)">
            @for (item of taxYearItems; track item.value) {
              <ap-dropdown-list-item #dropdownListItem [item]="item" [ariaLabel]="setTaxYearAriaLabel(item)"
                (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
        }
        <gtw-df-me-dropdown class="top-filter-select me-dropdown-label" [customActionCode]="32136"
          (selectedMes)="selectedMeChanged($event)">
        </gtw-df-me-dropdown>

        <ap-button [compact]="true" [btnType]="'primary'" [label]="'Filter'" (onClick)="loadReport()"></ap-button>

        <span class="toolbar-export" (click)="exportToExcel()">
          <span class="Appkit4-icon icon-save-outline"></span>
          <span>Export to Excel</span>
        </span>
      </div>
    </div>

    <div class="dst-mat-grid-layout">
      @if (loading) {
        <div class="dst-mat-grid-loading">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      }
      <div class="dst-mat-grid">
        <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort class="dst-mat-table">
          <ng-container matColumnDef="TAXYEAR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('TAXYEAR'))">
              {{ getColByField('TAXYEAR').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('TAXYEAR'))">
              <span>{{ rowData.TAXYEAR }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="STATEMENTID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('STATEMENTID'))">
              {{ getColByField('STATEMENTID').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('STATEMENTID'))">
              <a href="javascript:void(0);" (click)="showViewUpdateStatement(rowData)">
                <span>{{ rowData.STATEMENTID }}</span>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="STATEMENTNAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('STATEMENTNAME'))">
              {{ getColByField('STATEMENTNAME').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('STATEMENTNAME'))">
              <span>{{ rowData.STATEMENTNAME }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYBUSINESS">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('PRIMARYBUSINESS'))">
              {{ getColByField('PRIMARYBUSINESS').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('PRIMARYBUSINESS'))">
              <span>{{ rowData.PRIMARYBUSINESS }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('PRIMARYLEID'))">
              {{ getColByField('PRIMARYLEID').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('PRIMARYLEID'))">
              <span>{{ rowData.PRIMARYLEID }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYENTITY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('PRIMARYENTITY'))">
              {{ getColByField('PRIMARYENTITY').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('PRIMARYENTITY'))">
              <span>{{ rowData.PRIMARYENTITY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYCOUNTRYNAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('PRIMARYCOUNTRYNAME'))">
              {{ getColByField('PRIMARYCOUNTRYNAME').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('PRIMARYCOUNTRYNAME'))">
              <span>{{ rowData.PRIMARYCOUNTRYNAME }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYTAXTYPE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('PRIMARYTAXTYPE'))">
              {{ getColByField('PRIMARYTAXTYPE').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('PRIMARYTAXTYPE'))">
              <span>{{ rowData.PRIMARYTAXTYPE }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYALTTAXTYPE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('PRIMARYALTTAXTYPE'))">
              {{ getColByField('PRIMARYALTTAXTYPE').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('PRIMARYALTTAXTYPE'))">
              <span>{{ rowData.PRIMARYALTTAXTYPE }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="TRANSACTIONDATE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('TRANSACTIONDATE'))">
              {{ getColByField('TRANSACTIONDATE').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('TRANSACTIONDATE'))">
              <span>{{ rowData.TRANSACTIONDATE }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="DREPRIMARYSTARTDATE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('DREPRIMARYSTARTDATE'))">
              {{ getColByField('DREPRIMARYSTARTDATE').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('DREPRIMARYSTARTDATE'))">
              <span>{{ rowData.DREPRIMARYSTARTDATE }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="DREALERT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('DREALERT'))">
              {{ getColByField('DREALERT').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('DREALERT'))">
              <span>{{ rowData.DREALERT }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="REVIEW_EXPL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('REVIEW_EXPL'))">
              {{ getColByField('REVIEW_EXPL').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('REVIEW_EXPL'))">
              <span>{{ rowData.REVIEW_EXPL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="ISREVIEWED">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('ISREVIEWED'))">
              {{ getColByField('ISREVIEWED').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getDstColStyle(getColByField('ISREVIEWED'))">
              <span>{{ rowData.ISREVIEWED }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </div>
</div>

@if (showModalViewer) {
  <dst-disc-modal-viewer [rowObject]="activeRow" (afterModalClosed)="afterModalClosed()">
  </dst-disc-modal-viewer>
}
